import { setCookie } from './cookieUtils';
import {
  isBeta, isGamma, isLocal, isProd,
} from '../config/env';
import {
  LANGUAGE_CODE_COOKIE_NAME,
  LOCALE_LOCAL_STORAGE_KEY,
} from '../constants/localisation';
import { DEFAULT_LOCALE, LOCALES_MESSAGES_MAP } from '../config/i18n';

export const setLocaleForAuthPortal = (locale) => {
  if (isBeta() || isLocal()) {
    setCookie(LANGUAGE_CODE_COOKIE_NAME.BETA, locale);
  } else if (isGamma()) {
    setCookie(LANGUAGE_CODE_COOKIE_NAME.GAMMA, locale);
  } else if (isProd()) {
    setCookie(LANGUAGE_CODE_COOKIE_NAME.PROD, locale);
  }
};

export const setLocaleToLocalStorage = (locale) => {
  localStorage.setItem(LOCALE_LOCAL_STORAGE_KEY, locale);
};

export const getLocaleFromLocalStorage = () => localStorage.getItem(LOCALE_LOCAL_STORAGE_KEY);

export const getSupportedLocaleForDeviceLocale = () => {
  const { language } = window.navigator;
  return (
    (language
      && Object.keys(LOCALES_MESSAGES_MAP).find((locale) => {
        const deviceLanguageParts = language.split('-');

        return locale.startsWith(deviceLanguageParts[0]);
      }))
    || DEFAULT_LOCALE
  );
};
